import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PageCtx } from "@/lib/i18n";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";
import { Seo } from "./Seo";
import { WhatsAppButton } from "./Blocks";

export const SiteLayout = ({ lang, page, children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    localStorage.setItem("his_lang", lang);
  }, [lang]);
  return (
    <PageCtx.Provider value={{ lang, page }}>
      <div className="grain min-h-screen bg-ivory">
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[90] focus:rounded-full focus:bg-forest focus:px-4 focus:py-2 focus:text-ivory">Skip</a>
        <Seo />
        <Header />
        <main id="main">{children}</main>
        <Footer />
        {((lang === "tr" && page === "business") || page === "moving" || page === "living") && <div aria-hidden="true" data-testid="whatsapp-safe-space" className="h-24 bg-forest" />}
        {!(lang === "sl" && page === "business") && <WhatsAppButton />}
        <CookieBanner />
      </div>
    </PageCtx.Provider>
  );
};
